<template>
  <div class="customer-search-wrapper" v-animate-css="'fadeIn'">
    <div class="search-container">
      <h3 class="search-title">Search for Candidates</h3>
      <div class="search-inner-container">
        <div class="search-header">
          <div class="search-form">
            <div class="input-group">
              <span class="fa fa-search"></span>
              <input
                type="text"
                placeholder="Type in to Search…"
                v-model="keyword"
                @keyup="searchKeyword(1)"
              />
            </div>
          </div>
          <div class="search-options" v-if="false">
            <button
              class="filter-btn"
              :class="{ active: filter_type === 'location' }"
              @click="filterBy('location')"
            >
              Location
            </button>
            <button
              class="filter-btn"
              :class="{ active: filter_type === 'skills' }"
              @click="filterBy('skills')"
            >
              Skills
            </button>
            <button
              class="filter-btn"
              :class="{ active: filter_type === 'project' }"
              @click="filterBy('project')"
            >
              Projects
            </button>
            <button
              class="all-filter-btn"
              :class="{ active: filter_type === 'all' }"
              @click="filterBy('All')"
            >
              All filters
            </button>
          </div>
        </div>
        <div class="search-body" v-if="search_data.length > 0 && keyword">
          <ul class="search-items">
            <li class="search-item search-result-number">
              <span
                >Displaying {{ search_data.length | validate }} results</span
              >
            </li>
            <li
              class="search-result"
              v-for="(item, index) in search_data"
              :key="index + 'search'"
              @click="gotoProfile(item)"
            >
              <div class="search-item-logo">
                <img
                  v-if="item.profile_picture"
                  :src="$fullUrl('images/profiles/' + item.profile_picture)"
                />
                <img v-else src="@/assets/avatar.png" />
              </div>
              <div class="search-item-content">
                <strong class="search-title"
                  >{{ item.first_name | validate }}
                  {{ item.last_name | validate }}</strong
                >
                <!-- <span class="type">/Project</span> -->
                <br />
                <span v-if="item.account_type == 1" class="search-content"
                  >Candidates</span
                >
                <!-- <br />
                <label class="search-location">New York, USA</label>-->
              </div>
            </li>
          </ul>

          <div class="pagination-widget" v-if="false">
            <ul class="pagination paginate-links items">
              <li class="prev disabled">
                <a>Back</a>
              </li>
              <li class="next">
                <a>Next</a>
              </li>
            </ul>
            <ul class="pagination paginate-links items">
              <li class="number active">
                <a @click="searchKeyword(1)">1</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="search-body" v-else>No data searched, Type something.</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "search-widget",
  props: {},
  data: () => {
    return {
      search_data: [],
      keyword: "",
      filter_type: "all",
    };
  },
  mounted: {},
  methods: {
    filterBy(type) {
      this.filter_type = type;
    },
    searchKeyword(page) {
      let vm = this;
      vm.$store
        .dispatch("POST_SEARCH_CONSULTANTS", { query: vm.keyword })
        .then((response) => {
          vm.search_data = response.data.filter((item) => {
            return item.account_type == 1;
          });
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    gotoProfile(user) {
      this.hideSearch = true;
      this.searchHeader = "";
      if (user.account_type == 1)
        this.$router.push({ name: "profile-view", params: { id: user.id } });
      else if (user.account_type == 2)
        this.$router.push({
          name: "profile_customer",
          params: { id: user.id },
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-search-wrapper {
  padding-top: 10px;
  width: 800px;
  @media only screen and (max-width: 600px) {
    padding-top: 0px;
    width: 100%;
  }

  .search-container {
    background: #ffffff 0% 0% no-repeat padding-box;
    padding: 20px;
    border-radius: 5px;
    @media only screen and (max-width: 600px) {
      padding: 10px;
      border-radius: 0px;
    }
    .search-title {
      margin-top: 0px;
      margin-bottom: 20px;
      font-weight: 800;
    }
    .search-inner-container {
      background: #f5f5f5 0% 0% no-repeat padding-box;
      border-radius: 5px;
      padding: 20px;
      @media only screen and (max-width: 600px) {
        padding: 4px;
      }
      .search-header {
        display: flex;
        align-items: center;
        flex-direction: column;
        background: #fff;
        border-radius: 5px;
        margin-bottom: 15px;

        .search-form {
          width: 100%;
          padding: 10px 15px;
          .input-group {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 7px 20px;
            border-radius: 5px;
            border: 1px solid #eeeeee;
            input {
              height: 35px;
              width: 100%;
              border: none;
              font-size: 14px;
            }
            input:focus {
              outline: none;
            }
            input::placeholder {
              color: #d9d9d9;
            }
            span {
              color: #d8d8d8;
              margin-right: 20px;
            }
          }
        }
        .search-options {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 15px;
          .filter-btn {
            padding: 7px 20px;
            background: #efefef 0% 0% no-repeat padding-box;
            border-radius: 2px;
            color: #7c7c7c;
            font-size: 14px;
            border: none;

            width: 20%;
            cursor: pointer;
          }
          .filter-btn:hover {
            background: #1890a9 0% 0% no-repeat padding-box;
            color: #fff;
          }
          .filter-btn.active {
            background: #1890a9 0% 0% no-repeat padding-box;
            color: #fff;
          }
          .all-filter-btn {
            font-size: 14px;
            color: #00a5a6;
            background: transparent;
            border: none;
            border-left: 1px solid #ccc;
            padding: 10px 20px;
            width: 20%;

            cursor: pointer;
          }
        }
      }
      .search-body {
        ul {
          margin-left: -24px;
          list-style: none;
          margin-bottom: 0px;
          margin-right: 0px;

          .search-item {
            margin-bottom: 4px;
            span {
              color: #707070;
            }
          }
          .search-result-number {
            background: #fff;
            padding: 15px 19px;
            border-radius: 5px 5px 0px 0px;
            span {
              color: #707070;
            }
          }
          .search-result {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fff;
            padding: 5px 30px;
            margin-bottom: 4px;
            cursor: pointer;
            .search-item-logo {
              margin-right: 10px;
              img {
                border-radius: 50%;
                height: 40px;
                width: 40px;
                object-fit: cover;
              }
            }
            .search-item-content {
              width: 100%;
              padding-top: 0px;
              .search-title {
                font-size: 13px;
                color: #0884af;
              }
              .search-content {
                color: #4e4e4e;
              }
              .search-location {
                color: #b3b3b3;
              }
              .search-type {
                color: #b3b3b3;
              }
            }
          }
        }
        .pagination {
          display: flex;
          li {
            display: flex;
            height: 30px;
            width: 30px;
            justify-content: center;
            align-items: center;
            background: #fff;
          }
        }
      }
    }
  }
}
</style>
